import {
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import Highlighter from 'react-highlight-words';
import { connect } from 'react-redux';
import { getUser, moneyFormat } from 'src/utils/Common';
import { useTranslation } from 'react-i18next';
import {
  setLabourQuan,
  setLabourSelection,
  setLabourFilterKey
} from '../../store/actions';
import { setTask } from '../../store/actions/taskActions';
import { ROWS_CLEARED } from '@material-ui/data-grid';

const useStyles = makeStyles({
  table: {
    width: '100%',
    minHeight: 600,
    maxHeight: 600
  }
});

const LabourTable = props => {
  const { t } = useTranslation('work_order');
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const selected = props.labours[props.defect] || [];
  const SessionUser = getUser();
  let selectedAll = [];
  if (props.selectedDefects) {
    props.selectedDefects.forEach(d => {
      if (props.labours[d]) selectedAll = [...selectedAll, ...props.labours[d]];
    });
  }
  const handleClick = (event, name, disabled, row) => {
  if (disabled) {
    return;
  }

  const selectedIndex = selected.indexOf(name);
  let newSelected = [];

  if (selectedIndex === -1) {
    // Add
    newSelected = [...selected, name];
  } else {
    // Remove
    newSelected = [
      ...selected.slice(0, selectedIndex),
      ...selected.slice(selectedIndex + 1)
    ];
  }

  props.setLabourFilterKey('');
  props.setLabourSelection(props.defect, newSelected);

  // Bu tıklamadan SONRA bu labour seçili mi?
  const isNowSelected = selectedIndex === -1;

  if (props.onLabourSelect && row) {
    // row'u kopya gönder + durum + yeni seçim listesi
    props.onLabourSelect({ ...row }, isNowSelected, newSelected);
  }
};


  const handleClose = () => {
    setOpen(false);
  };
  const isSelected = name => selected && selected.indexOf(name) !== -1;
  const isUsedBefore = name => selectedAll && selectedAll.indexOf(name) !== -1;

  const highlight = text => {
    return (
      <Highlighter
        searchWords={[props.labours.filterKey]}
        autoEscape
        textToHighlight={text}
      />
    );
  };
  
  return (
    <>
      <TableContainer className={classes.table} component={Paper}>
        <Table size="small" aria-label="labour table">
          <TableBody>
            {props.labours.filtered &&
                props.labours.filtered
                .slice() // ← BURAYA eklenecek
                .sort(s => (isUsedBefore(s.LabourCode) ? -1 : 1))
                .slice(0, 50)
                .map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
                  const isItemSelected = isSelected(row.LabourCode);
                  const isItemUsedBefore = isUsedBefore(row.LabourCode);
                  const disabled = isItemUsedBefore && !isItemSelected;
                  return (
                    <TableRow
                      onClick={event =>
                        handleClick(event, row.LabourCode, disabled, row)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.LabourCode}
                      selected={isItemSelected}
                    >
                      <TableCell component="th" scope="row">
                        <b>{highlight(row.LabourCode)}</b> 
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {highlight(row.LabourDesc)}
                      </TableCell>
                      {
                        SessionUser.ServiceShopPriceVisible ?
                          <>
                            <TableCell component="th" scope="row">
                              <b>
                                <Chip
                                  size="small"
                                  label={`${moneyFormat(
                                    // Pakistanlılar Fiyatları değişik istemiş
                                    // O yüzden yapılmış
                                    SessionUser.TenantId == 75 ? row.Price*100/(row.VatRate*100+100) : row.Price, //vatRate=20/100 Ex: 29.17Pkr -> 35.00Pkr
                                    SessionUser.TenantCode,
                                    SessionUser.CurrencyUnit
                                  )} ${SessionUser.CurrencyUnit}`}
                                />
                              </b>
                            </TableCell>
                            <TableCell component="th" scope="row" align="right">
                              <b>{'%' + (row.VatRate * 100).toFixed(2)}</b>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <b>
                                <Chip
                                  size="small"
                                  label={`${moneyFormat(
                                    // Pakistanlılar Fiyatları değişik istemiş
                                    // O yüzden yapılmış
                                    SessionUser.TenantId == 75 ? row.Price : row.Price + (row.Price * row.VatRate),
                                    SessionUser.TenantCode,
                                    SessionUser.CurrencyUnit
                                  )} ${SessionUser.CurrencyUnit}`}

                                />
                              </b>
                            </TableCell>
                          </> : null}
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isItemSelected || isItemUsedBefore}
                          inputProps={{ 'aria-labelledby': labelId }}
                          color="primary"
                          disabled={disabled}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
          </TableBody>
        </Table>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary">
            {t('Bilgilendirme')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {Uyari}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              {t('Tamam')}
            </Button>
          </DialogActions>
        </Dialog>
      </TableContainer>
    </>
  );
};
const mapStateToProps = state => ({
  labours: state.labourReducer,
  selectedDefects: state.defectReducer.selected,
  tasks: state.tasks1
});

const mapDispatchToProps = {
  setLabourSelection,
  setLabourQuan,
  setLabourFilterKey,
  setTask
};

export default connect(mapStateToProps, mapDispatchToProps)(LabourTable);
